import { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import './LunchCreator.scss';
import MultistepForm from "./multistepForm/MultistepForm";
import { createLunch, areFieldsFilled, validateLunch } from "../../../utils/model/lunch";
import { createDish } from "../../../utils/model/dish";
import MenuCreator from "./menu/MenuCreator";
import LunchInfoCreator from "./lunchInfo/LunchInfoCreator";
import { getDefaultDate, moveDate } from "../../../utils/date";
import { showErrorToast } from "../toasts/utils";
import LunchPreview from "./preview/LunchPreview";

const LunchCreator = ({template, onSubmit, submitLabel, initialStep}) => {
    const [dishes, setDishes] = useState([]);
    const [title, setTitle] = useState();
    const [description, setDescription] = useState();
    const [company, setCompany] = useState();
    const [companyUrl, setCompanyUrl] = useState();
    const [endDate, setEndDate] = useState(getDefaultDate());
    useEffect(() => {
        const {
            options: templateOptions = [createDish()],
            title: templateTitle = '',
            description: templateDescription = '',
            company: templateCompany = '',
            companyUrl: templateCompanyUrl = '',
            endDate: templateEndDate = getDefaultDate(),
        } = template || {};
        setDishes(templateOptions);
        setTitle(templateTitle);
        setDescription(templateDescription);
        setCompany(templateCompany);
        setCompanyUrl(templateCompanyUrl);
        setEndDate(moveDate(templateEndDate));
    }, [template]);

    const handleSubmit = () => {
        const lunch = createLunch(
            title,
            description,
            company,
            companyUrl,
            dishes,
            endDate
        );
        try {
            validateLunch(lunch);
            onSubmit(lunch);
        } catch (error) {
            showErrorToast([error.message]);
        }
    };

    const isValid = areFieldsFilled(title, description, company, companyUrl, endDate);
    return (
        <div className="page lunch">
            <p className="page-header">Description of the menu</p>
            <MultistepForm
                isValid={!!isValid}
                onSubmitClick={handleSubmit}
                submitLabel={submitLabel}
                initialStep={initialStep}
            >
                <LunchInfoCreator
                    title={title}
                    setTitle={setTitle}
                    description={description}
                    setDescription={setDescription}
                    company={company}
                    setCompany={setCompany}
                    companyUrl={companyUrl}
                    setCompanyUrl={setCompanyUrl}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <MenuCreator
                    dishes={dishes}
                    setDishes={setDishes}
                />
                <LunchPreview
                    title={title}
                    description={description}
                    dishes={dishes}
                    company={company}
                    companyUrl={companyUrl}
                    endDate={endDate}
                />
            </MultistepForm>
        </div>
    );
}

LunchCreator.propTypes = {
    submitLabel: PropTypes.string,
    template: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    initialStep: PropTypes.number
}

export default LunchCreator;
